export const typeOfSearchProgressModal = 'typeOfSearchProgressModal';
export const searchProgressModalReducerKey = 'searchProgressModalReducerKey';
export const RESET_STATE = 'RESET_STATE';
export const UPDATE_STATE_PARAMS = 'UPDATE_STATE_PARAMS';
